const React = require('react');

const Content = require('./Content.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// function _ItemMeta(props) { return <Content.LabelValue {...props} formatValue={false} value={props.content} /> }
function _ItemMeta(props) {
    const hasValue = !Utilities.isHTMLContentEmpty(props.content);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const ItemMeta = Content.withLabelTokenParsing(_ItemMeta, Token.TypeParsing.inventory);
const TypeConfigItemMeta = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block(1),
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: Content.TypeConfig.labelValue.panelV2.label,
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: Content.TypeConfig.labelValue.panelV2.value
        // value: (data) => Content.TypeConfig.labelValue.panelV2.value(TypeConfigItemMeta.defaultDesign(data))
    }
};

module.exports = {
    Component: ItemMeta,
    TypeConfig: TypeConfigItemMeta
}